"use client";

import { useEffect, useRef } from "react";
import { useAuthInit, useAuthUser } from "hooks/useAuth";
import { useCartStore } from "context/cartStore";

// Generate unique session ID for this page load
const SESSION_ID =
  typeof window !== "undefined" ? Math.random().toString(36) : "ssr";

export default function AuthBoot() {
  useAuthInit();
  const user = useAuthUser();
  const fetchCart = useCartStore((state) => state.fetchCart);
  const lastSessionId = useRef(null);

  useEffect(() => {
    if (!user) {
      lastSessionId.current = null;
      return;
    }

    // Only fetch once per page load (SESSION_ID changes on refresh)
    if (lastSessionId.current === SESSION_ID) {
      return;
    }

    // ALWAYS fetch from server for logged-in users
    // This ensures DB is source of truth, avoiding localStorage stale data issues
    fetchCart(user);

    lastSessionId.current = SESSION_ID;
  }, [user, fetchCart]);

  return null;
}
